import React from 'react';
import styles from '../../Styles/Modules/Loader.module.scss';
import { useTranslation } from 'react-i18next';

const loaderBars = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const LoaderCustom = ({ hidden }) => {
  const { t } = useTranslation();

  return (
    <div className={`${styles.loader} ${hidden ? styles.loaderHidden : ''}`}>
      <div className={styles.loaderContainer}>
        {loaderBars.map((bar) => (
          <div
            key={bar}
            className={`${styles.loaderBar} ${styles[`loaderBar${bar}`]}`}
          ></div>
        ))}
      </div>

      <div className={styles.loaderText}>
        {t('loading')}...
      </div>
    </div>

  );
};

export default LoaderCustom;
